module.exports = __webpack_public_path__ + "img/危品WCA_01.3569ebf8.webp";